import { TCompanyState } from '@/redux/reducers/company';
import { TGetLicensePriceSuccess } from '@/redux/actions/company';

export const getLicensePriceUpdateState = (state: TCompanyState, action: TGetLicensePriceSuccess): TCompanyState => {
  const updatedState = {
    ...state,
    licensePriceResponse: action.payload.response,
  };
  return updatedState;
};
